import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgBergruimte = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      d="M21 15H5v16h16zM35 11h-8v8h8z"
    />
    <path
      fill="#00C5F2"
      d="M33 19H21v12h12z"
    />
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M18 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgBergruimte);

export default ForwardRef;
